<template>
    <div id="konfigurator-rasa">
        <h1>{{ 'Breed' | translate }}</h1>

        <div v-show="(!isValidRasa() || !isValidVelikost()) && tryEscape" class="info-messages-box">
            <div v-if="!isValidRasa() && tryEscape" class="error-msg">{{ 'You have to select a breed' | translate }}</div>
            <div v-if="!isValidVelikost() && tryEscape" class="error-msg">{{ 'You have to select a size' | translate }}</div>
        </div>

        <div class="form-content">

            <div class="rasa-krizenec">
                <div class="form-radios">
                    <div class="form-type-radio" :key="key" v-for="(item, key) in rasaTypItems">
                        <input type="radio" @change="changeTyp(item.val)" v-model="mazlicek.rasa.typ"
                               v-bind:value="item.val"
                               :id="item.val">
                        <label :for="item.val">
                            {{ item.title }}
                        </label>

                    </div>
                </div>
            </div>

            <div class="rasa-krizenec-vyber"
                 v-bind:class="{ 'has-error':!isValidRasa() && tryEscape }">
                <autocomplete
                        :keyword="mazlicek.rasa.autocomplete.keyword"
                        :options="rasaItems"
                        @select="rasaSelect"
                        v-if="mazlicek.rasa.typ === 'app_rasa'"
                >
                </autocomplete>

                <div class="form-radios" v-if="mazlicek.rasa.typ === 'app_velikost'"
                     v-bind:class="{ 'has-error':!isValidVelikost() && tryEscape }">
                    <h2 class="konf-subtitle">{{ 'Select the closest' | translate }}:</h2>
                    <div class="form-type-radio" :key="key" v-for="(item, key) in velikostItems">
                        <input type="radio" @change="changeSizePriceRatio" v-model="mazlicek.rasa.velikost" v-bind:value="item.id" :id="item.id">
                        <label :for="item.id">
                            <div class="item-title">{{ item.title }}</div>
                            <div v-if="item.description.length > 0" class="item-desc" v-html="item.description"></div>
                        </label>
                    </div>
                </div>
            </div>

        </div>

        <info :krok="2"></info>

        <navigace
                :showPrev="true"
                :onClickPrev="prev"
                :showNext="true"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>

    </div>
</template>

<script>
    import {apiSilex} from '../api'
    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'
    import autocomplete from './Autocomplete'
    import navigace from './Navigace'
    import info from './Info'
    import translateFilter from '../services/translator.js';

    export default {
        components: {
            autocomplete, navigace, info
        },
        mixins: [validationMixin],
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                rasaTypItems: [
                    {title: this.translateFilter('I know the breed'), val: 'app_rasa'},
                    {title: this.translateFilter('I don´t know the breed'), val: 'app_velikost'}
                ],
                rasaItems: [],
                velikostItems: [],
                emptykrizenec: this.$store.state.mazlicek.jmeno.value !== null,
                tryEscape: false
            }
        },
        computed: {
            valid: function () {
                return (this.mazlicek.rasa.valid = !this.$v.rasaValid.$invalid)
            }
        },
        methods: {
            translateFilter,
            animateAfterError(){
                jQuery('html, body').animate({
                        scrollTop: jQuery('.app-content-left').offset().top - jQuery('#primary').height()
                    },
                    '500'
                )
            },
            isValidRasa: function () {
                let mazlicekRasa = this.mazlicek.rasa
                let isValid
                if (mazlicekRasa.typ === 'app_rasa') {
                    isValid = mazlicekRasa.autocomplete.keyword.length !== 0 && mazlicekRasa.id.length !== null
                } else {
                    isValid = true
                }
                return isValid
            },
            isValidVelikost: function () {
                let mazlicekRasa = this.mazlicek.rasa
                let isValid
                if (mazlicekRasa.typ === 'app_velikost') {
                    isValid = mazlicekRasa.velikost !== null
                } else {
                    isValid = true
                }
                return isValid
            },
            validateComplete: function () {
                return this.isValidVelikost() && this.isValidRasa()
            },
            changeTyp: function (val) {
                // this.mazlicek.rasa.id = null
                // this.mazlicek.rasa.autocomplete.keyword = ''
                this.tryEscape = false
            },
            rasaSelect: function (val) {
                this.mazlicek.rasa.id = val.id
                this.mazlicek.rasa.autocomplete.keyword = val.title
                const rasa = this.rasaItems.find(item => item.id == this.mazlicek.rasa.id)
                const velikost = this.velikostItems.find(item => item.id == rasa.id_velikost)

              this.mazlicek.rasa.priceRatio = velikost.koeficient_ceny
            },
            changeSizePriceRatio: function(){
              let ratio = 1
              if(this.mazlicek.rasa.velikost){
                const velikost = this.velikostItems.find(item => item.id == this.mazlicek.rasa.velikost)
                ratio = velikost.koeficient_ceny
              }

              this.mazlicek.rasa.priceRatio = ratio
            },
            prev: function () {
                this.$router.push({name: 'jmenomazlicka'})
            },
            next: function () {
                if (this.validateComplete()) {
                    if (this.mazlicek.rasa.typ === 'app_velikost') {
                        this.mazlicek.rasa.autocomplete.keyword = ''
                        this.mazlicek.rasa.id = null
                    } else {
                        this.mazlicek.rasa.velikost = null
                    }
                    this.$store.dispatch('updatePet', this.mazlicek)
                        .then(response => {
                            this.$router.push({name: 'fotografie'})
                        }, error => {
                            console.error(error)
                        })
                    this.mazlicek.rasa.valid = true
                } else {
                    this.tryEscape = true
                    this.animateAfterError()
                }
            },
            saveAndQuit: function () {
              if (this.validateComplete()) {
                if (this.mazlicek.rasa.typ === 'app_velikost') {
                  this.mazlicek.rasa.autocomplete.keyword = ''
                  this.mazlicek.rasa.id = null
                } else {
                  this.mazlicek.rasa.velikost = null
                }
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                    window.location.href = 'prihlaseni'
                  }, error => {
                    console.error(error)
                  })
                this.mazlicek.rasa.valid = true
              } else {
                this.tryEscape = true
                this.animateAfterError()
              }
            }
        },
        validations: {
            mazlicek: {
                rasa: {
                    id: {},
                    velikost: {}
                }
            },
            rasaValid() {
                return required(this.mazlicek.rasa.id) || required(this.mazlicek.rasa.velikost)
            }
        },
        mounted: function () {
            this.mazlicek.step.current = 2
            this.$cookies.set('lastVisitedStep', 2)
            jQuery('html, body').animate({scrollTop: 0}, '500')
            apiSilex.get('/rasa').then(
                response => (this.rasaItems = response.data)
            )
            apiSilex.get('/velikost').then(
                response => (this.velikostItems = response.data)
            )
        },
    }
</script>



// WEBPACK FOOTER //
// 02Rasa.vue?42dde298